import React from 'react';

const Badge = ({ count, className = '', children, ...props }) => {
    if (!count || count <= 0) return null;
    return (
        <span className={`badge ${className}`} {...props}>
            {children || count}
        </span>
    );
};

export default Badge;
